import { FlatList } from 'react-native';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import Separator from '@src/components/Separator';
import {
  idKeyExtractor,
  maxWidth,
  padding,
  windowWidth,
} from '@src/configuration/constants';

import { AllCollections } from './types';

export const headerHeight = windowWidth / 1.77;

export const Content = styled.View`
  padding-top: ${padding}px;
  padding-bottom: ${padding}px;
`;

export const ContentWrapper = styled.View`
  padding-left: ${padding}px;
  padding-right: ${padding}px;
`;

export const Cover = styled(Image)`
  width: ${windowWidth}px;
  height: ${headerHeight}px;
  resize-mode: contain;
`;

export const List = styled(
  FlatList as new () => FlatList<AllCollections>
).attrs(() => ({
  removeClippedSubviews: true,
  scrollEventThrottle: 8,
  initialNumToRender: 1,
  maxToRenderPerBatch: 1,
  keyExtractor: idKeyExtractor,
  ItemSeparatorComponent: Separator,
  contentContainerStyle: {
    paddingBottom: padding,
    maxWidth: maxWidth,
    marginHorizontal: 'auto',
    width: '100%',
  },
}))``;
